import * as React from 'react';
import { Grid } from '@mui/material';
import { SparkTabs } from 'sharedComponents/UI';
import UsageTab from './UsageTab';
import SparkRunsTab from './SparkRunsTab';
import type { HistoryFilter } from '.';

type SparksHistoryResultProps = {
  historyFilter: HistoryFilter;
};

function SparksHistoryResult({ historyFilter }: SparksHistoryResultProps) {
  const initialTabIndex =
    historyFilter.sparkIDs && historyFilter.sparkIDs.length > 0 ? 1 : 0;
  const [selectedTab, setSelectedTab] = React.useState(initialTabIndex);

  return (
    <Grid container>
      <Grid item container sx={{ paddingTop: '3rem' }}>
        <SparkTabs
          // height={300}
          scrollableContainerStyle={{ overflow: 'visible' }}
          scrollableGridProps={{ overflow: 'visible' }}
          tabItems={[
            {
              label: 'Usage',
              content: <UsageTab historyFilter={historyFilter} />,
            },
            {
              label: 'Spark Runs',
              content: <SparkRunsTab historyFilter={historyFilter} />,
            },
          ]}
          selectedItemIndex={selectedTab}
          onChange={setSelectedTab}
        />
      </Grid>
    </Grid>
  );
}

export default SparksHistoryResult;
